import * as React from "react";

import NavigationDropdown from "~/components/navigation/navigation-dropdown/navigation-dropdown";
import NavigationDropdownSection from "~/components/navigation/navigation-dropdown/navigation-dropdown-section/navigation-dropdown-section";
import NavigationSpot, {
    INavigationSpotProps
} from "~/components/navigation/navigation-dropdown/navigation-spot/navigation-spot";
import NavigationList from "~/components/navigation/navigation-dropdown/navigation-list/navigation-list";
import { IBaseLink } from "~/types/link";

export enum NavigationLinkType {
    SUBMENU = "submenu",
    LINK = "link",
    DIVIDER = "divider"
}

export interface INavigationLink extends IBaseLink {
    type: NavigationLinkType;
    spotContent?: INavigationSpotProps;
    links?: INavigationLink[];
}

export interface INavigationPrimaryLinksProps {
    links: INavigationLink[];
}

const NavigationPrimaryLinks: React.SFC<INavigationPrimaryLinksProps> = props => {
    const wrapperClasses = "navigation-primary-links";
    const itemClasses = "navigation-primary-links__list-item";
    const generateLinks = (links: INavigationLink[]): React.ReactNode[] => {
        return links.reduce((generatedLinks: React.ReactNode[], item: INavigationLink, index: number) => {
            if (item.type === "link") {
                generatedLinks.push(
                    <li key={index} className={itemClasses}>
                        <a
                            className="navigation-primary-links__link reset-a"
                            href={item.url}
                            target={item.target}
                        >
                            <div className="navigation-primary-links__link-inner">
                                <span>{item.label}</span>
                            </div>
                        </a>
                    </li>
                );
            }

            if (item.type === "submenu") {
                generatedLinks.push(
                    <li key={index} className={itemClasses}>
                        <NavigationDropdown {...item}>
                            {item.spotContent && (
                                <NavigationDropdownSection
                                    className="navigation-dropdown__section--spot"
                                    {...item.spotContent}
                                >
                                    <NavigationSpot {...item.spotContent} />
                                </NavigationDropdownSection>
                            )}
                            <NavigationDropdownSection {...item}>
                                {item.links && <NavigationList linkList={item.links} />}
                            </NavigationDropdownSection>
                        </NavigationDropdown>
                    </li>
                );
            }
            return generatedLinks;
        }, []);
    };

    return (
        <div className="navigation-primary-links-wrapper">
            <ul className={wrapperClasses}>{generateLinks(props.links)}</ul>
        </div>
    );
};

export default NavigationPrimaryLinks;
